import type {
  SbContentPage,
  StoryblokStory,
} from '~/cms/storyblok/types/storyblok.d.ts'

const useTranslatedSlug = (data: Ref<StoryblokStory<SbContentPage>>) => {
  const currentShop = useCurrentShop()

  const slug = computed(() => {
    const slugs: { lang: string; name: string | null; path: string }[] =
      data.value?.translated_slugs || []

    return slugs.find((slug) => slug.lang === currentShop.value.locale)
  })

  const name = computed(() => slug.value?.name || data.value?.name)
  const path = computed(() =>
    (slug.value?.path || data.value?.full_slug)?.replace(/\/$/, ''),
  )

  return {
    translatedSlug: slug,
    name,
    path,
  }
}

export default useTranslatedSlug
